<template>
  <div>
    <line-chart
      v-if="mydata && myType == 'linechart' && !drawing"
      :chart-data="mydata"
      :options="options"
    />
    <bar-chart
      v-if="mydata && myType == 'barchart' && !drawing"
      :chart-data="mydata"
      :options="options"
    />
    <v-btn small @click="chartFormat('barchart')">Barras</v-btn>
    <v-btn small @click="chartFormat('linechart')">Línea</v-btn>
  </div>
</template>

<script>
import IndicatorMixin from '../../mixins/IndicatorMixin.js';

export default {
  mixins: [IndicatorMixin],

  data: () => ({
    mydata: null,
    myType: 'linechart',
    indicator: 'IPM',
  }),
};
</script>
